import { TextInput } from "@mantine/core";
import { useForm } from "@mantine/hooks";
import React from "react";
import { Answer, QuestionQuestionSelect } from "../type";

const QuestionSelectBMI: React.VFC<{
    questionSelects: QuestionQuestionSelect[];
    currentQuestionNo: number;
    dispatch: Function;
    lastAnswers: Answer[];
}> = (props) => {
    const MAX_NUMBER: number = 300;
    const MIN_NUMBER: number = 1;

    //@ts-ignore
    const { weight, height } =
        !!props.lastAnswers &&
        props.lastAnswers.length > 0 &&
        props.lastAnswers[0].answer
            ? props.lastAnswers[0].answer
            : { weight: "", height: "" };

    const form = useForm({
        initialValues: {
            height,
            weight,
        },

        validationRules: {
            height: (value) =>
                parseInt(value) >= MIN_NUMBER &&
                parseInt(value) <= MAX_NUMBER &&
                /^[0-9]+$/.test(value.toString()),
            weight: (value) =>
                parseInt(value) >= MIN_NUMBER &&
                parseInt(value) <= MAX_NUMBER &&
                /^[0-9]+$/.test(value.toString()),
        },
    });

    const handleAnswer = ({ height, weight }) => {
        const bmi = calculateBMI({ height, weight });
        const questionSelect = selectQuestionSelectFromBMI(bmi);

        props.dispatch({
            type: "ANSWER",
            nextQuestionNo: questionSelect.next_question_no,
            questionNo: props.currentQuestionNo,
            answer: {
                height,
                weight,
                bmi,
            },
            question_select: questionSelect,
        });
    };

    const calculateBMI = ({ weight, height }) => {
        return (weight / ((height / 100) * (height / 100))).toFixed(2);
    };

    const selectQuestionSelectFromBMI = (bmi) => {
        switch (true) {
            case bmi <= 18.5:
                return props.questionSelects.find((q) => q.text == "18.5以下");
            case bmi > 18.5 && bmi < 24:
                return props.questionSelects.find((q) => q.text == "18.5～24");
            case bmi >= 24:
                return props.questionSelects.find((q) => q.text == "24以上");
        }
    };

    return (
        <form
            className="mt-10"
            onSubmit={form.onSubmit((values) =>
                handleAnswer({
                    height: parseInt(values.height),
                    weight: parseInt(values.weight),
                })
            )}
        >
            <div className="flex flex-row px-6">
                <TextInput
                    className="skrwd-TextInput Option-cm w-1/2 pr-2"
                    required
                    label="身長"
                    type="number"
                    error={form.errors.height && "身長を入力してください"}
                    value={form.values.height}
                    onChange={(event) => {
                        form.setFieldValue("height", event.currentTarget.value);
                    }}
                />
                <TextInput
                    className="skrwd-TextInput Option-kg w-1/2 pl-2"
                    required
                    label="体重"
                    type="number"
                    error={form.errors.weight && "体重を入力してください"}
                    value={form.values.weight}
                    onChange={(event) => {
                        form.setFieldValue("weight", event.currentTarget.value);
                    }}
                />
            </div>
            <div className="skrwd-Fixed-OKButton-Container">
                <button className="skrwd-OKButton" type="submit">
                    OK
                </button>
            </div>
        </form>
    );
};

export default QuestionSelectBMI;
